import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { isNullOrEmpty, translate } from '../../utils/util';
import { SelectItem } from './ComponentsUI';
import ContainerService from '../../services/ContainerService';
import useStateWithPromise from '../../utils/useEffectUpdate';

const SelectMaritimeCompany = (props) => {
    const [maritimeCompanyList, setMaritimeCompanyList] = useStateWithPromise([]);
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        if (!isNullOrEmpty(props.defaultValue)) {
            if (props.maritimeCompanyList && props.maritimeCompanyList.find(f => f.id === props.defaultValue)) {
                setMaritimeCompanyList(props.maritimeCompanyList).then(() => {
                    const node1 = document.getElementById(props.id || "maritimeCompany");
                    const node2 = document.getElementById(node1.M_Dropdown.id)
                    if (node2 && node2.children[0]) {
                        node2.children[0].click()
                    }
                });
                setIsLoading(false)
                props.onChange(props.maritimeCompanyList.find(f => f.id === props.defaultValue))
            } else {
                setIsLoading(true);
                let filter = { id: props.defaultValue };
                props.load(filter, (data) => {
                    setMaritimeCompanyList([...data]).then(() => {
                        const node1 = document.getElementById(props.id || "maritimeCompany");
                        const node2 = document.getElementById(node1.M_Dropdown.id)
                        if (node2 && node2.children[0]) {
                            node2.children[0].click()
                        }
                    });
                    setIsLoading(false)
                    props.onChange(data[0])
                });
            }
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (isNullOrEmpty(props.value)) {
            document.getElementById(props.id || "maritimeCompany").value = "";
        }
        // eslint-disable-next-line
    }, [props.value]);

    const onChange = (event) => {
        const value = event.target.value;
        if (!isNullOrEmpty(value) && value.length > 2) {
            setIsLoading(true);
            let filter = { name: value };
            props.load(filter, (data) => {
                if (data) {
                    setMaritimeCompanyList([...data]);
                    setIsLoading(false);
                }
            });
        }
    }

    const onChangeData = (event) => {
        if (props.onChange) {
            props.onChange(maritimeCompanyList.find(f => f.id === event.target.value))
        }
    }

    return (
        <SelectItem
            {...props}
            isLoading={isLoading}
            id={props.id || "maritimeCompany"}
            label="Companhia Maritima"
            placeHolder={translate('general:choose-one-option')}
            minLength={0}
            onChange={onChange}
            onChangeData={onChangeData}
            changeEvent="true"
            data={maritimeCompanyList ? maritimeCompanyList.map((i) => {
                return { id: i.id, text: `${i.id}-${i.name}` };
            }) : []} />
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        maritimeCompanyList: state.containerReducer.maritimeCompanyList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        load: (filter, callback) => {
            dispatch(ContainerService.getMaritimeCompany(filter, callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectMaritimeCompany));
